const createAllThemes = (themes, createTheme) => Object.entries(themes).reduce((acc, [key, value]) => {
    const themeName = toThemeKey(key);
    acc[key] = createTheme(themeName, value);
    return acc;
}, {});
const toProviderThemes = (createdThemes) => Object.entries(createdThemes).reduce((acc, [key, value]) => {
    acc[key] = value.className;
    return acc;
}, {});
const toThemeKey = (key) => key.replaceAll(" ", '-') + '-theme';

export { createAllThemes, toProviderThemes, toThemeKey };
